import { computed } from 'vue';
import { useFeatureStore } from '@/store/featureStore';

export function useFeatureFlag(name) {
  const store = useFeatureStore();
  return computed(() => store.isEnabled(name));
}
